module.exports = __webpack_public_path__ + "static/media/new-edit-icon.7918fa52.svg";